// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__3PKCG","layer":"layer__1ks+-","threesixtyIcon":"threesixtyIcon__pGUJo","label":"label__ZfWz2"};